import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2a4dfd24 = () => interopDefault(import('../pages/expert-review/index.vue' /* webpackChunkName: "pages/expert-review/index" */))
const _75e88b5a = () => interopDefault(import('../pages/invoices/index.vue' /* webpackChunkName: "pages/invoices/index" */))
const _91fa2352 = () => interopDefault(import('../pages/order/index.vue' /* webpackChunkName: "pages/order/index" */))
const _1c6abc50 = () => interopDefault(import('../pages/partners/index.vue' /* webpackChunkName: "pages/partners/index" */))
const _0bd1fda6 = () => interopDefault(import('../pages/order/ai-proofreader.vue' /* webpackChunkName: "pages/order/ai-proofreader" */))
const _ffe17efc = () => interopDefault(import('../pages/order/essay.vue' /* webpackChunkName: "pages/order/essay" */))
const _170d53ea = () => interopDefault(import('../pages/plagiarism-check/example.vue' /* webpackChunkName: "pages/plagiarism-check/example" */))
const _485bce44 = () => interopDefault(import('../pages/profile/billing/index.vue' /* webpackChunkName: "pages/profile/billing/index" */))
const _29c229a4 = () => interopDefault(import('../pages/profile/contact-preferences/index.vue' /* webpackChunkName: "pages/profile/contact-preferences/index" */))
const _c1282f0e = () => interopDefault(import('../pages/profile/edit-profile/index.vue' /* webpackChunkName: "pages/profile/edit-profile/index" */))
const _59db3975 = () => interopDefault(import('../pages/widgets/user-modal.vue' /* webpackChunkName: "pages/widgets/user-modal" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _9f14bbc0 = () => interopDefault(import('../pages/plagiarism-orders/freemium/_id/index.vue' /* webpackChunkName: "pages/plagiarism-orders/freemium/_id/index" */))
const _4ba8f61e = () => interopDefault(import('../pages/checkout/_id/index.vue' /* webpackChunkName: "pages/checkout/_id/index" */))
const _d5a357c6 = () => interopDefault(import('../pages/ai-proofreader-orders/_id/ai-detector.vue' /* webpackChunkName: "pages/ai-proofreader-orders/_id/ai-detector" */))
const _0ccad297 = () => interopDefault(import('../pages/ai-proofreader-orders/_id/overview.vue' /* webpackChunkName: "pages/ai-proofreader-orders/_id/overview" */))
const _aa79cfdc = () => interopDefault(import('../pages/own-sources-checker/_id/show.vue' /* webpackChunkName: "pages/own-sources-checker/_id/show" */))
const _626f884b = () => interopDefault(import('../pages/plagiarism-orders/_id/details.vue' /* webpackChunkName: "pages/plagiarism-orders/_id/details" */))
const _3f4df540 = () => interopDefault(import('../pages/plagiarism-orders/_id/overview.vue' /* webpackChunkName: "pages/plagiarism-orders/_id/overview" */))
const _3376b044 = () => interopDefault(import('../pages/plagiarism-orders/_id/show.vue' /* webpackChunkName: "pages/plagiarism-orders/_id/show" */))
const _4674f4ee = () => interopDefault(import('../pages/proofreading-orders/_id/details.vue' /* webpackChunkName: "pages/proofreading-orders/_id/details" */))
const _622595ee = () => interopDefault(import('../pages/proofreading-orders/_id/feedback.vue' /* webpackChunkName: "pages/proofreading-orders/_id/feedback" */))
const _4813c606 = () => interopDefault(import('../pages/proofreading-orders/_id/overview.vue' /* webpackChunkName: "pages/proofreading-orders/_id/overview" */))
const _da63177a = () => interopDefault(import('../pages/proofreading-orders/_id/workflow.vue' /* webpackChunkName: "pages/proofreading-orders/_id/workflow" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/student/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/expert-review",
    component: _2a4dfd24,
    name: "expert-review"
  }, {
    path: "/invoices",
    component: _75e88b5a,
    name: "invoices"
  }, {
    path: "/order",
    component: _91fa2352,
    name: "order"
  }, {
    path: "/partners",
    component: _1c6abc50,
    name: "partners"
  }, {
    path: "/order/ai-proofreader",
    component: _0bd1fda6,
    name: "order-ai-proofreader"
  }, {
    path: "/order/essay",
    component: _ffe17efc,
    name: "order-essay"
  }, {
    path: "/plagiarism-check/example",
    component: _170d53ea,
    name: "plagiarism-check-example"
  }, {
    path: "/profile/billing",
    component: _485bce44,
    name: "profile-billing"
  }, {
    path: "/profile/contact-preferences",
    component: _29c229a4,
    name: "profile-contact-preferences"
  }, {
    path: "/profile/edit-profile",
    component: _c1282f0e,
    name: "profile-edit-profile"
  }, {
    path: "/widgets/user-modal",
    component: _59db3975,
    name: "widgets-user-modal"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }, {
    path: "/plagiarism-orders/freemium/:id",
    component: _9f14bbc0,
    name: "plagiarism-orders-freemium-id"
  }, {
    path: "/checkout/:id",
    component: _4ba8f61e,
    name: "checkout-id"
  }, {
    path: "/ai-proofreader-orders/:id?/ai-detector",
    component: _d5a357c6,
    name: "ai-proofreader-orders-id-ai-detector"
  }, {
    path: "/ai-proofreader-orders/:id?/overview",
    component: _0ccad297,
    name: "ai-proofreader-orders-id-overview"
  }, {
    path: "/own-sources-checker/:id?/show",
    component: _aa79cfdc,
    name: "own-sources-checker-id-show"
  }, {
    path: "/plagiarism-orders/:id?/details",
    component: _626f884b,
    name: "plagiarism-orders-id-details"
  }, {
    path: "/plagiarism-orders/:id?/overview",
    component: _3f4df540,
    name: "plagiarism-orders-id-overview"
  }, {
    path: "/plagiarism-orders/:id?/show",
    component: _3376b044,
    name: "plagiarism-orders-id-show"
  }, {
    path: "/proofreading-orders/:id?/details",
    component: _4674f4ee,
    name: "proofreading-orders-id-details"
  }, {
    path: "/proofreading-orders/:id?/feedback",
    component: _622595ee,
    name: "proofreading-orders-id-feedback"
  }, {
    path: "/proofreading-orders/:id?/overview",
    component: _4813c606,
    name: "proofreading-orders-id-overview"
  }, {
    path: "/proofreading-orders/:id?/workflow",
    component: _da63177a,
    name: "proofreading-orders-id-workflow"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
